import { combineReducers } from 'redux'
import {
  IGlobalMessagingState,
  IMapboxState,
  INotesState,
  IShipmentsState,
  ITagsState,
} from 'types'
import globalMessagingReducer from 'utils/reducers/globalMessaging'
import mapboxReducer from 'utils/reducers/mapbox'
import notesReducer from 'utils/reducers/notes'
import pathReducer, { IPathState } from 'utils/reducers/path'
import shipmentReducer from 'utils/reducers/shipment'
import shipmentsReducer from 'utils/reducers/shipments'
import tagsReducer from 'utils/reducers/tags'
import uiReducer from 'utils/reducers/ui'
import userDriverLocationsReducer from 'utils/reducers/userDriverLocations'
import userProfileReducer from 'utils/reducers/userProfile'
import { IUIState } from 'apps/booking/types'
import { IUserDriverLocations, IUserProfile } from 'apps/user/types/user'
import { IShipmentState } from '../types'
import { accessTokenReducer } from './accessToken'

export interface IStore {
  shipmentData: IShipmentState
  shipmentUpdate: IShipmentsState
  notes: INotesState
  ui: IUIState
  mapbox: IMapboxState
  path: IPathState
  userDriverLocations: IUserDriverLocations
  userProfile: IUserProfile
  tags: ITagsState
  accessToken: {
    token: string
  }
  globalMessaging: IGlobalMessagingState
}

const reducers = combineReducers({
  shipmentData: shipmentReducer,
  shipmentUpdate: shipmentsReducer,
  notes: notesReducer,
  ui: uiReducer,
  mapbox: mapboxReducer,
  path: pathReducer,
  userDriverLocations: userDriverLocationsReducer,
  userProfile: userProfileReducer,
  tags: tagsReducer,
  accessToken: accessTokenReducer,
  globalMessaging: globalMessagingReducer,
})

export default reducers
